<template>
  <div class="yanbao-tab">
    <div class="content-box" v-if="ratingInfos.length > 0">
      <p class="title">评级统计</p>
      <ul class="tabheader">
        <li>时间段</li>
        <li>买入</li>
        <li>增持</li>
        <li>中性</li>
        <li>减持</li>
        <li>卖出</li>
        <li>总家数</li>
      </ul>
      <ul class="tabbody" v-for="(item, index) in ratingInfos" :key="index">
        <li>{{item.foreYear | toStr}}</li>
        <li>{{item.buying}}</li>
        <li>{{item.overweight}}</li>
        <li>{{item.normal}}</li>
        <li>{{item.underweight}}</li>
        <li>{{item.sell}}</li>
        <li>{{item.total}}</li>
      </ul>
    </div>
    <div style="height: 0.06rem;background: #f5f5f5;"></div>
    <div class="content-box" v-if="profitInfos.length > 0">
      <p class="title">盈利预测</p>
      <ul class="tabheader">
        <li>年份</li>
        <li>ROE<span style="color:#f43737">预</span></li>
        <li>EPS<span style="color:#f43737">预</span></li>
        <li>PE<span style="color:#f43737">预</span></li>
      </ul>
      <ul class="tabbody" v-for="(item, index) in profitInfos" :key="index">
        <li>{{item.foreYear}}</li>
        <li>{{item.roe.toFixed(2) + '%'}}</li>
        <li>{{item.eps.toFixed(3)}}</li>
        <li>{{item.pe.toFixed(2)}}</li>
      </ul>
    </div>
    <div style="height: 0.06rem;background: #f5f5f5;"></div>
    <div class="content-box">
      <p class="title">最新研报</p>
      <div class="tabs-list">
        <div v-for="(item, $index) in tabs[2].list" :key="$index" class="tab-item" @click="goDetail(item)">
          <p class="tab-title">{{item.title}}</p>
          <div class="tab-label">
            <div>
              <span>{{item.orgName}}</span>
              <i :class="`tab-icon ${item.className}`"></i>
              <span v-show="item.tarPrice > 0" class="tarprice">目标价:<span class="price" style="color: #333;">{{item.tarPrice.toFixed(2)}}</span></span>
            </div>
            <span>{{item.publishDate | showtime}}</span>
          </div>
        </div>
        <infinite-loading @infinite="infiniteHandler" direction="bottom" :distance="100" :forceUseInfiniteWrapper="true">
          <div slot="no-more">无更多数据</div>
          <div v-if="tabs[2].list.length === 0" slot="no-results" class="no-results">
          </div>
          <div v-else slot="no-results">
          </div>
          <div slot="spinner" class="tab-spinner">正在加载...</div>
        </infinite-loading>
      </div>
    </div>
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import {request} from '@/api/request'
import {mapState} from 'vuex'
import moment from 'moment'

export default {
  data() {
    return {
      ratingInfos: [],
      profitInfos: []
    }
  },
  computed: {
    ...mapState({
      code: state => state.code,
      market: state => state.market,
      symbol: state => state.symbol,
      tabs: state => state.common.tabs,
      tabIndex: state => state.common.tabIndex
    })
  },
  components: {InfiniteLoading},
  created() {
    this.getRatingInfo()
    this.getProfitInfo()
  },
  methods: {
    goDetail(yanbao) {
      // console.log('yanbao', yanbao)
      this.$router.push(`/detail/${this.market}/${this.symbol}/3/${yanbao.id}.html`)
    },
    async getProfitInfo() {
      let res = await request.get({
        url: request.apis.quote.profitInfo,
        params: {
          symbol: this.code,
          market: this.market
        }
      })
      console.log('res', res)
      this.profitInfos = res || []
    },
    async getRatingInfo() {
      let res = await request.get({
        url: request.apis.quote.ratingInfo,
        params: {
          symbol: this.code,
          market: this.market
        }
      })
      this.ratingInfos = res || []
    },
    async infiniteHandler($state) {
      let canload = await this.getListData()
      if (canload) $state.loaded()
      else $state.complete()
    },
    /**
     * 获取list 数据
     */
    async getListData() {
      let res = await request.get({
        url: request.apis.quote.newsOne,
        params: {
          symbol: this.code,
          page: this.tabs[2].pageNo++,
          pageSize: 30
        }
      })
      if (res.length > 0) {
        this.tabs[2].list = this.tabs[2].list.concat(res).map(_ => {
          switch (_.ratingId) {
            case 0:
              _.className = 'wupingji'
              break;
            case 1:
              _.className = 'maichu'
              break;
            case 2:
              _.className = 'jianchi'
              break;
            case 3:
              _.className = 'zhongxing'
              break;
            case 5:
              _.className = 'zengchi'
              break;
            case 7:
              _.className = 'mairu'
              break;
            default:
              _.className = 'wupingji'
              break;
          }
          return _
        })
        if (res.length > 0) return true
        else return false
      } else return false     
    }
  },
  filters: {
    showtime(_date) {
      let day = moment(new Date())
      let date = moment(_date)
      if (day.year() === date.year() && day.dayOfYear() === date.dayOfYear()) {
        return `${date.hour().toString().padStart(2, 0)}:${date.minute().toString().padStart(2, 0)}`
      } else if (day.year() === date.year()) {
        return `${(date.month() + 1).toString().padStart(2, 0)}-${date.date().toString().padStart(2, 0)}`
      } else {
        return `${date.year()}-${(date.month() + 1).toString().padStart(2, 0)}-${date.date().toString().padStart(2, 0)}`
      }
    },
    toStr(val) {
      if (val === 12) return '1年内'
      if (val < 12) return `${val}个月` 
    }
  }
}
</script>

<style lang="stylus" scoped>
.yanbao-tab
  .content-box
    .tabs-list
      display flex
      flex-flow column
      min-height 100vh
      .no-results
        background url('../../../assets/no_data.png')
        height 200px
        width 200px
        background-size cover
        margin 50px auto
      .tab-spinner
        font-size 13px
        padding 15px 0 30px 0
        color: #999
      .tab-item
        padding 10px 8px
        border-bottom 1px solid #f5f5f5
        .tab-title
          font-size 15px
          color #333
          // height 22px
          line-height 21px
          font-weight 400
          overflow : hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        .tab-label
          display flex
          justify-content space-between
          font-size 12px
          color #999
          margin-top 5px
          &>div
            display flex
            align-items center
          .tab-icon
            width 33px
            height 15px
            display block
            margin-left 6px
          .zengchi
            background url('../../../assets/zengchi.png')
            background-size cover
          .wupingji
            background url('../../../assets/wupingji.png')
            width 41px
            background-size cover
          .maichu
            background url('../../../assets/maichu.png')
            background-size cover
          .zhongxing
            background url('../../../assets/zhongxing.png')
            background-size cover
          .mairu
            background url('../../../assets/mairu.png')
            background-size cover
          .tarprice
            margin-left 15px
    .tabheader
      display flex
      padding 0 12px
      padding-top 6px
      flex 1
      // justify-content space-between
      li
        font-size 13px
        color #999
        flex 1
        text-align center
        &:first-child
          text-align left
        &:last-child
          text-align right
    .tabbody
      display flex
      padding 0 12px
      flex 1
      // justify-content space-between
      li
        font-size 13px
        flex 1
        padding 5px 0
        text-align center
        &:first-child
          text-align left
        &:last-child
          text-align right
    .title
      font-size 15px
      color #333333
      font-weight 600
      height 21px
      line-height 21px
      margin 0px 12px
      padding 6px 0
      border-bottom 1px solid #edeff3
</style>